module.exports = __webpack_public_path__ + "static/media/reception-1.8088ffdd.jpg";